import { api } from "../api";

export const clientDetailsApi = (data) => {
  return api.post(`/client/details`, JSON.stringify(data));
};

export const agreementDetailsApi = (data) => {
  return api.post(`/client/agreements-details`, JSON.stringify(data));
};

export const agreementDetailsOtpApi = (data) => {
  return api.post(`/client/send-otp-agreements-details`, JSON.stringify(data));
};

export const agreementDetailsEsignApi = (data) => {
  return api.post(`/client/sign-agreements-details`, JSON.stringify(data));
};



export const recordViewCountApi = (data) => {
  return api.post(`/client/record-profile-view`, JSON.stringify(data));
};

export const profileStatusUpdateApi = (data) => {
  return api.post(`/client/record-profile-status`, JSON.stringify(data));
};



export const empAgreementDetailsApi = (data) => {
  return api.post(`/client/emp-agreements-details`, JSON.stringify(data));
};

export const empAgreementDetailsOtpApi = (data) => {
  return api.post(`/client/emp-send-otp-agreements-details`, JSON.stringify(data));
};

export const empAgreementDetailsEsignApi = (data) => {
  return api.post(`/client/emp-sign-agreements-details`, JSON.stringify(data));
};

